import React, {Component} from 'react';

import {connect} from 'react-redux';

import {toggleCollapsedNav} from '../redux/action/Theme';

import TopNav from './header/TopNav';
import Sidebar from './sidebar/Sidebar';
import PageFooter from './footer/PageFooter';

import classNames from 'classnames';

class Layout extends Component {

    constructor(props){
        super(props);

        this.state = {
             dataHover: props.navCollapsed
        };
    }

    componentDidMount = () => {
        const {toggleCollapsedNav, appRoutes, windowWidth} = this.props;

        if(appRoutes && windowWidth >= 1200){ toggleCollapsedNav(false); }
    }

    componentDidUpdate = (prevProps) => {
        if(prevProps.navCollapsed !== this.props.navCollapsed){
            setTimeout( () => {
                this.setState({ dataHover: this.props.navCollapsed });
            }, 250);
        }
    }

    render = () => {
        const { children, navCollapsed, appRoutes, error404Route, isPrintRoute } = this.props;
        const { dataHover } = this.state;

        if (isPrintRoute) {
            return children; 
        }

        return (
            <div
                className={classNames("hk-wrapper", {"hk-pg-auth": error404Route})}
                data-layout="vertical"
                data-layout-style={navCollapsed ? "collapsed" : "default"}
                data-menu="light"
                data-footer="simple"
                data-hover={dataHover ? "active" : ""}
            >
                <TopNav />
                <Sidebar />
                <div className={classNames("hk-pg-wrapper", {"pb-10" : appRoutes})}>
                    {children}
                    { appRoutes && (<PageFooter />)}
                </div>
            </div>
        )

    }
}

const mapStateToProps = ({theme}) => {
    const {navCollapsed, topNavCollapsed} = theme;
    return {navCollapsed, topNavCollapsed}
};

const withRouterAndWindow = (Component) => (props) => {
    const windowWidth = window.innerWidth;
    const pathname = window.location.pathname;

    const isPrintRoute = /^\/apps\/[a-zA-Z0-9]+-print\/[a-zA-Z0-9-]+$/.test(pathname);
    const appRoutes = pathname.startsWith('/apps/') && !isPrintRoute;

    const error404Route = window.location.pathname === '/error-404';

    return (
        <Component 
            {...props}
            windowWidth={windowWidth}
            appRoutes={appRoutes}
            isPrintRoute={isPrintRoute}
            error404Route={error404Route}
        />
    )
}

export default connect(mapStateToProps, {toggleCollapsedNav})(withRouterAndWindow(Layout));